import Crud from "../Crud";
import Format from "../Format";
import moment from "moment";
import { purple } from "@mui/material/colors";

/**
 * Static helper functions related to Inbound Files.
 */
export default class InboundFile extends Crud {
  /**
   * @param {object} inboundFile The inboundFile object.
   * @returns {string} The display name of the inbound file.
   */
  static getDisplayName(inboundFile) {
    const senderName = inboundFile.senderName?.trim();
    const senderContact = Format.phone(inboundFile.senderContact);

    return [senderName, senderContact].filter(Boolean).join(" - ");
  }

  /**
   * Sorts inbound files by newest timestamp first.
   * @param {array} inboundFiles - The inbound files.
   * @param {string} key - createdAt | deletedAt
   * @returns {array} The sorted inbound files.
   */
  static sort(inboundFiles, key = "createdAt") {
    return [...inboundFiles].sort((firstInboundFile, secondInboundFile) => {
      const first = firstInboundFile[key]
        ? moment(firstInboundFile[key]).valueOf()
        : 0;
      const second = secondInboundFile[key]
        ? moment(secondInboundFile[key]).valueOf()
        : 0;
      return second - first;
    });
  }

  /**
   * @returns {string} The color of this object.
   */
  static getBaseColor() {
    return purple;
  }

  /**
   * @returns {string} The icon name for this object.
   */
  static getIconName() {
    return "File";
  }
}
